

class PayoutModalHelper {

    /**
     * Binds input data to user class.
     * 
     * @param response: payoutNumber
     * @returns void
     */
    static bind(payoutNumber) {
        $('.payout-pin').html(payoutNumber);
    };

    /**
     * Shows login errors.
     * 
     * @param error string
     */
    static logErorr(error) {
        $('.payout-pin').val(error);
    }

    /**
     * Open modal.
     * 
     * @returns void.
     */
    static openModal() {
        $('.payout-modal').modal('show');
    }

    /**
     * Close modal.
     * 
     * @returns void.
     */
    static closeModal() {
        $('.payout-modal').modal('hide');
    }
}

export default PayoutModalHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/js/helpers/payout-modal-helper.js
// module id = 1544
// module chunks = 11